import * as tslib_1 from "tslib";
import { Api } from './api.service';
var CommonApi = /** @class */ (function (_super) {
    tslib_1.__extends(CommonApi, _super);
    function CommonApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.controllerName = 'api/common';
        return _this;
    }
    CommonApi.prototype.getEquipmentTypes = function () {
        return this.get(this.controllerName + "/get-equipment-types");
    };
    CommonApi.prototype.getUserSetting = function () {
        return this.get('api/common/get-user-setting');
    };
    CommonApi.prototype.getCountries = function () {
        return this.get(this.controllerName + "/get-countries");
    };
    CommonApi.prototype.getTimezone = function () {
        return this.get(this.controllerName + "/get-timezone");
    };
    CommonApi.prototype.getUserNotifications = function () {
        return this.get(this.controllerName + "/get-user-notifications");
    };
    CommonApi.prototype.countUnreadUserNotification = function () {
        return this.get(this.controllerName + "/count-unread-user-notification");
    };
    CommonApi.prototype.updateAllNotificaionAsRead = function () {
        return this.get(this.controllerName + "/update-all-notification-as-read");
    };
    CommonApi.prototype.getCurrencies = function () {
        return this.get(this.controllerName + "/get-currencies");
    };
    CommonApi.prototype.getRequestConfiguration = function () {
        return this.get(this.controllerName + "/get-request-configuration");
    };
    CommonApi.prototype.getFreightPostConfiguration = function () {
        return this.get(this.controllerName + "/get-freight-post-configuration");
    };
    CommonApi.prototype.getCompanyLogo = function (userId) {
        return this.get(this.controllerName + "/get-company-logo/" + userId);
    };
    CommonApi.prototype.getCurrentUser = function () {
        return this.get(this.controllerName + "/get-current-user");
    };
    CommonApi.prototype.getBusinessUnitByOrganizationId = function (organizationId) {
        return this.get(this.controllerName + "/get-business-unit/" + organizationId);
    };
    CommonApi.prototype.updateLanguage = function (lang) {
        return this.get(this.controllerName + "/update-language/" + lang);
    };
    CommonApi.prototype.sendContactEmail = function (command) {
        return this.post(this.controllerName + "/send-contact-email", command);
    };
    CommonApi.prototype.getAppConfiguration = function () {
        return this.get(this.controllerName + "/get-app-configuration");
    };
    return CommonApi;
}(Api));
export { CommonApi };
